import { render, staticRenderFns } from "./IconPrinterSolid.vue?vue&type=template&id=b10d3c16"
import script from "./IconPrinterSolid.vue?vue&type=script&lang=js"
export * from "./IconPrinterSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports